import { useSelector } from 'react-redux'
import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import { OrderInterface } from '../../../../../common/types/interfaces'
import classes from './Item.module.sass'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import edit from '../../../../../assets/images/icons/edit.svg'
import search from '../../../../../assets/images/icons/search.svg'
import { format } from 'date-fns'
import {
  getDeliveryTypeText,
  getOrderStatusColor,
  getOrderStatusText,
  getPaymentMethodText,
  getPaymentStatusColor,
  getPaymentStatusText,
} from '../../../../../common/utils/functions/enumToText'
import { OrderStatus } from '../../../../../common/types/enums'

type Props = {
  startEdit: (el: OrderInterface) => void
  el: OrderInterface
  showDetails: (el: OrderInterface) => void
  isConnected: boolean
}

export const Item = ({ startEdit, el, showDetails, isConnected }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)

  return (
    <div
      className={darkTheme ? classes.containerDark : classes.container}
      style={{
        filter:
          el.status === OrderStatus.DELIVERED ||
          el.status === OrderStatus.CANCELLED ||
          el.status === OrderStatus.PICKED_UP
            ? 'opacity(0.7)'
            : 'opacity(1)',
      }}
    >
      <div className={classes.contentContainer}>
        <div className={classes.id}>
          <div className={classes.label}>id</div>
          <div className={classes.value}>{el.id}</div>
        </div>
        <div>
          {el.createdAt && (
            <div className={classes.date}>
              <div className={classes.label}>Создан</div>
              <div className={classes.value}>
                {format(new Date(el.createdAt), 'dd.MM.yyy HH:mm')}
              </div>
            </div>
          )}
          {el.updatedAt && (
            <div className={classes.date}>
              <div className={classes.label}>Обновлен</div>
              <div className={classes.value}>
                {' '}
                {format(new Date(el.updatedAt), 'dd.MM.yyy HH:mm')}
              </div>
            </div>
          )}
        </div>
        <div className={classes.item}>
          <div className={classes.label}>Позиций в заказе</div>
          <div className={classes.value}>{el.items?.length}</div>
        </div>
        <div className={classes.item}>
          <div className={classes.label}>Тип доставки</div>
          <div className={classes.value}>{getDeliveryTypeText(el.deliveryType)}</div>
        </div>
        <div className={classes.item}>
          <div className={classes.label}>Тип оплаты </div>
          <div className={classes.value}>{getPaymentMethodText(el.paymentMethod)}</div>
        </div>
        <div className={classes.item}>
          <div className={classes.label}>Оплачен</div>
          <div className={classes.value} style={{ color: getPaymentStatusColor(el.paymentStatus) }}>
            {getPaymentStatusText(el.paymentStatus)}
          </div>
        </div>
        <div className={classes.item}>
          <div className={classes.label}>Статус</div>
          <div className={classes.value} style={{ color: getOrderStatusColor(el.status) }}>
            {getOrderStatusText(el.status)}
          </div>
        </div>
        {el.total && (
          <div className={classes.item}>
            <div className={classes.label}>Сумма</div>
            <div className={classes.value}>{el.total.toLocaleString('ru-RU')} ₽</div>
          </div>
        )}
      </div>

      <div className={classes.buttons}>
        <IconButton
          display
          onClick={() => {
            showDetails(el)
          }}
          icon={search}
          alt="Детали"
          small
        />
        <IconButton
          disabled={!isConnected}
          display
          onClick={() => {
            startEdit(el)
          }}
          icon={edit}
          alt="Изменить"
          small
        />
      </div>
    </div>
  )
}
